<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.address' | translate }}
  </label>
  <input type="text" class="form-control" id="address" formControlName="address"  [ngClass]="{ 'is-invalid': campaignForm.get('address')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
